// extracted by mini-css-extract-plugin
export default {"heading":"Tt-z","corrected":"Ut-z","redirectVerbiageContainer":"Vt-z","redirectVerbiageText":"Wt-z"};